/*
 * @Description:
 * @Author: doris_xu
 * @Date: 2023-04-14 13:30:08
 * @LastEditTime: 2025-06-11 09:17:30
 */
import { Modal } from 'antd'
import { useEffect, useState } from 'react'
import { getEnv } from '../../../helpers/mobx-easy-wrapper'
import ActivityRouter from '../../routers/activity-router'

const Enter = () => {
  const [collegeFlag, setCollegeFlag] = useState(true)
  const [visible, setVisible] = useState(true)
  const [isLogin, setIsLogin] = useState(false)

  useEffect(() => {
    setCollegeFlag(window.location.href.indexOf('uncomgroup') > 0)
    const { apiFactory } = getEnv()
    const loginFlag = apiFactory.authService.isAuthenticated()
    setIsLogin(loginFlag)
  }, [isLogin])

  const handleCancel = () => {
    setVisible(false)
    // window.localStorage.setItem('report', '1');
  }

  return (
    <div className="home" style={{ width: '1200px', margin: '0 auto' }}>
      <div className="jury__line outlineTitle" style={{ textAlign: 'center' }}>
        <label
          className={`enter_label  ${collegeFlag ? 'active' : ''}`}
          onClick={() => (window.location.href = '/enter/uncomgroup')}>
          未转化组
        </label>
        <div className={`split__line`}></div>
        <label
          className={`enter_label  ${!collegeFlag ? 'active' : ''}`}
          onClick={() => (window.location.href = '/enter/comgroup')}>
          已转化组
        </label>
      </div>
      {visible && isLogin && (
        <Modal
          wrapClassName={'enter_modal'}
          visible={true}
          centered={true}
          closable={false}
          footer={[
            <button
              key={'closeButton'}
              type="button"
              className={'lite__sub__button'}
              onClick={handleCancel}>
              我已阅读并同意
            </button>,
          ]}>
          <div
            dangerouslySetInnerHTML={{
              __html: `<p style="text-align: center;"><strong>报名须知</strong></p>
    <p style="text-indent: 24pt;">一、赛道设置</p>
    <p style="text-indent: 24pt;">2025上高赛面向全国范围内所有科技领域涉及的专利运营项目皆可参赛。参赛赛道重点围绕：</p>
    <p style="text-indent: 24pt;">1. 生命健康与智慧医疗：基因与细胞治疗、AI+医疗、脑科学与神经工程等；</p>
    <p style="text-indent: 24pt;">2. 新一代信息技术与通信：量子信息、6G与未来网络、半导体革新等；</p>
    <p style="text-indent: 24pt;">3. 绿色能源与碳中和：清洁能源技术、碳中和解决方案、新能源载体等；</p>
    <p style="text-indent: 24pt;">4. 人工智能与智能生态：AI核心技术、AI场景应用、通用技术突破等；</p>
    <p style="text-indent: 24pt;">5. 先进制造与高端装备：精密仪器与传感器、低空经济、工业智能升级、航空航天等；</p>
    <p style="text-indent: 24pt;">6. 合成生物与生物制造：合成生物技术、生物制造应用、未来食品科技等；</p>
    <p style="text-indent: 24pt;">7. 先进材料：材料制造与应用、材料计算设计等；</p>
    <p style="text-indent: 24pt;">同时向全赛道、全领域计划实施或正在实施高价值专利运营的项目开放参赛。</p>
    <p style="text-indent: 24pt;">二、大赛组别</p>
    <p style="text-indent: 24pt;">本次大赛分成<span style="font-weight:bold;color:#444;">未转化组</span>和<span style="font-weight:bold;color:#444;">已转化组</span>两个组别，全国范围内的创新主体（高校、科研院所、医疗卫生机构、企业、科创团队等）均可参赛，其中：</p>
    <p style="text-indent: 24pt;">1、未转化组：参赛创新主体拥有的尚未实施转化但计划实施转化的项目。重点考察项目的<span style="font-weight:bold;color:#444;">转化潜力</span>，包括其专利先进性、专利转化路径（路径设想描述）、市场预期（预期产生的经济效益及社会效益）以及距离市场化的远近（技术成熟度和市场对技术的需求度）。</p>
    <p style="text-indent: 24pt;">2、已转化组：参赛创新主体拥有的已实施转化或正在转化中的专利项目。重点考察项目的<span style="font-weight:bold;color:#444;">转化成效</span>，包括核心专利运营产生的经济效益及社会效益，同时，转化路径描述及材料凭证作为附加评判项。</p>
    <p style="text-indent: 24pt;">三、参赛要求</p>
    <p style="text-indent: 24pt;">1、专利稳定性：参赛的专利项目需具备较强的对抗无效请求的能力，并满足专利稳定性的基本要求。</p>
    <p style="text-indent: 24pt;">2、核心专利：参赛项目专利要求至少指定一项（不超过三项）专利作为参赛核心专利，核心专利为当年5月1日前已申请或授权的有效专利，无知识产权纠纷，近两年新推向市场或准面市的项目优先。</p>
    <p style="text-indent: 24pt;">3、专利权人：如果参赛项目的核心专利为多个专利权人，参赛申请人应征得其他专利权人的同意。</p>
    <p style="text-indent: 24pt;">4、专利运营团队：参赛项目的运营团队核心成员不少于 3人（含 3 人）。</p>
    <p style="text-indent: 24pt;">5、联合参赛：参赛核心专利、专利稳定性、专利权人要求同独立参赛要求一致。</p>
    <p style="text-indent: 24pt;"> （1）允许跨组别、同组别至少2个主体、最多4个主体联合参赛。</p>
    <p style="text-indent: 24pt;"> （2）允许金融机构、知识产权服务机构与企业、高校院所、医疗卫生机构联合参赛，荣誉共享，以服务案例（尚未实施转化但计划实施转化、已实施转化或正在转化中的均可）、专利项目等进行参赛。</p>
    <p style="text-indent: 24pt;"> （3）服务机构联合参赛实行回避制度，同一个服务机构不能派员同时参加比赛和评委工作。</p>`,
            }}
          />
        </Modal>
      )}
      <ActivityRouter />
    </div>
  )
}

export default Enter
